import Api from 'dash/src/services/Api';
import { Language } from '@vestahealthcare/common/enums';

export const fetchSupportedLanguages = async (): Promise<Language[]> => {
  const { languages } = await Api.getv2('/languages');
  return languages.items.map((item: any) => Language.byKey[item.value]);
};
